module.exports = __webpack_public_path__ + "static/media/core_team01.2ee2fab0.png";